export default __webpack_public_path__ + "static/media/Frame11.de6fdbaf.jpg";